import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-gray-800 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <img src="/logo.png" alt="Phobia Games" className="w-20 h-auto" />
            <span className="text-xl font-black text-white font-montserrat">PHOBIA GAMES</span>
          </div>
          <p className="text-gray-400 mb-4 font-medium">
            Qorxunun ən dərin nöqtələrinə səyahət edin
          </p>
          <p className="text-gray-600 font-medium">
            © 2025 Phobia Games. Bütün hüquqlar qorunur.
          </p>
        </div>
      </div>
    </footer>
  );
};
